import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AnalyticsResultsService, IncomeVsSpendStatistic } from 'src/app/shared/services/analytics-results.service';

@Component({
  selector: 'app-income-stat',
  templateUrl: './income-stat.component.html',
  styleUrls: ['../widgets.scss', './income-stat.component.scss']
})
export class IncomeStatComponent implements OnInit {
  incomeAmount: number | undefined;
  constructor(private resultsAnalyticsSvc: AnalyticsResultsService) { }
  ngOnInit(): void {
    this.resultsAnalyticsSvc.getIncomeVsSpendStatistics()
      .subscribe({
        next: (data: IncomeVsSpendStatistic[]) => {
          this.calculateIncome(data);
        },
        error: (err: HttpErrorResponse) => {
          console.log("error loading income vs spend statistics");
          console.log(err);
        }
      });
  }


  calculateIncome(incomeData: IncomeVsSpendStatistic[]) {
    if(incomeData && incomeData.length > 0) {
      let income = 0;
      let now = new Date(Date.now());
      let begin = this.addMonths(now, -12);

      let endMonthYear = this.getMonthYearNumber(now);
      let beginMonthYear = this.getMonthYearNumber(begin);

      incomeData.forEach((x) => {
        let monthYear = x.dim_txndate_yearmonth as number;
        if( monthYear >= beginMonthYear && monthYear <= endMonthYear) {
          if(x.fct_income !== undefined) {
          income = income + x.fct_income;
          }
        }
      });

      this.incomeAmount = income;
    }
  }

  addMonths(at: Date, months: number): Date {
    let d = new Date(at);
    d.setMonth(d.getMonth() + months);

    return d;
  }

  getMonthYearNumber(at: Date): number {
    return (at.getFullYear() * 100) + at.getMonth() + 1;
  }
}
